/**
 * @typedef {Object} NavItem
 * @property {string} label
 * @property {string=} href
 * @property {boolean=} subMain   // 섹션 랜딩(서브메인) 페이지 → 2뎁스(메가)에서는 숨김
 * @property {boolean=} hidden    // 라우팅 전용 숨김
 * @property {string=} roleOnly     // 특정 권한만 접근 가능 ('admin' 등)
 * @property {boolean=} hiddenInGnb // gnb 내 숨김
 * @property {boolean=} hiddenInSitemap // 사이트맵 내 숨김
 * @property {NavItem[]=} children
 */
const { REACT_APP_ADMIN_PAGE_PATH, REACT_APP_LAB_PAGE_PATH } = process.env;
// 루트 메뉴: 1뎁스 배열
export const ROOT_NAV = [
  {
    label: '마이페이지',
    href: undefined,
    hiddenInGnb: true,
    children: [
      { label: '나의 수강강좌', href: '/mypage/courses', noProfessor: true},
      { label: '나의 문의', href: '/mypage/inquiry', noProfessor: true},
      { label: '강좌관리', href: '/mypage/management', professorOnly: true },
      { label: '강좌Q&A관리', href: '/mypage/qna', professorOnly: true },
      { label: '관심콘텐츠', href: '/mypage/interested' },
      { label: '내가본콘텐츠', href: '/mypage/viewed' },
      { label: '내정보관리', href: '/mypage/account/account-check' },
      { label: '내정보관리', href: '/mypage/account', hidden: true },
    ],
  },
  {
    label: '사업소개',
    href: undefined,
    children: [
      { label: 'OpenVLab 이란?', href: '/about/intro' },
      { label: '플랫폼 안내', href: '/about/platform' },
      { label: '사업홍보', href: '/about/promotion' },
    ],
  },
  {
    label: '강좌·콘텐츠',
    href: undefined,
    children: [
      { label: 'VLab 강좌', href: '/contents/lecture', },
      { label: 'VLab 강좌', href: '/contents/lectureview', hidden: true, },
      { label: 'XR콘텐츠', href: '/contents/xr', },
      { label: 'XR콘텐츠', href: '/contents/xrview', hidden: true, },
    ],
  },
  
  // 1차 오픈 안함
  // {
  //   label: 'OpenVLabAPI',
  //   href: undefined,
  //   children: [
  //     { label: '서비스 소개', href: '/api/service' },
  //     { label: 'API 이용절차', href: '/api/process' },
  //     { label: 'API문서 및 신청안내', href: '/api/doc' },
  //     { label: 'API 이용문의', href: '/api/inquiry' },
  //   ],
  // },

  {
    label: '알림공간',
    href: undefined,
    children: [
      { label: '공지사항', href: '/alarm/notice' },
      { label: '공지사항', href: '/alarm/noticeview', hidden: true, },
      { label: 'FAQ', href: '/alarm/faq' },
      { label: '이용문의 및 제안', href: '/alarm/inquiry' },
    ],
  },
  {
    label: '가상실험실습체험관',
    // href: 'https://dev.openvlab.kr/lab',
    href: REACT_APP_LAB_PAGE_PATH,
    target: '_blank',
  },
  { label: '회원가입', href: '/signup', hiddenInGnb: true, hiddenInSitemap: true, },
  { label: '로그인', href: '/login', hiddenInGnb: true, hiddenInSitemap: true, },
  { label: '아이디 찾기', href: '/recoveremailaccount', hiddenInGnb: true, hiddenInSitemap: true, },
  { label: '아이디 찾기', href: '/recoveremailaccountlater', hiddenInGnb: true, hiddenInSitemap: true, },
  { label: '비밀번호 찾기', href: '/recoverpassword', hiddenInGnb: true, hiddenInSitemap: true, },
  { label: '비밀번호 찾기', href: '/recoverpasswordlater', hiddenInGnb: true, hiddenInSitemap: true, },
  { label: '비밀번호 재설정', href: '/resetpassword', hiddenInGnb: true, hiddenInSitemap: true, },
  { label: '비밀번호 재설정', href: '/resetpasswordlater', hiddenInGnb: true, hiddenInSitemap: true, },
  { label: '휴면계정안내', href: '/inactivity', hiddenInGnb: true, hiddenInSitemap: true, },
  { label: '휴면계정안내', href: '/inactivityphone', hiddenInGnb: true, hiddenInSitemap: true, },
  { label: '휴면계정안내', href: '/inactivityemail', hiddenInGnb: true, hiddenInSitemap: true, },
  { label: '휴면계정안내', href: '/inactivitylater', hiddenInGnb: true, hiddenInSitemap: true, },

  { label: '이용약관', href: '/policy/terms', hiddenInGnb: true, hiddenInSitemap: true,  },
  { label: '개인정보처리방침', href: '/policy/privacy', hiddenInGnb: true, hiddenInSitemap: true, },
  { label: '저작권보호정책', href: '/policy/copyright', hiddenInGnb: true, hiddenInSitemap: true, },

  { label: '검색결과', href: '/search', hiddenInGnb: true, hiddenInSitemap: true, },

  // {
  //   label: '테스트공간',
  //   href: '/Test',
  //   hiddenInGnb: true,
  //   children: [
  //     { label: '게시판메인', href: '/Test' },
  //     { label: '컴포넌트-캘린더', href: '/Test/calendarTest' },
  //     { label: '컴포넌트-카드', href: '/Test/cardTest' },
  //     { label: '컴포넌트-라디오', href: '/Test/radioTest' },
  //     { label: '컴포넌트-셀렉트박스', href: '/Test/selectBoxTest' },
  //     { label: '샘플-레벨 셀렉트박스', href: '/Test/levelCombo' },
  //     { label: '샘플-엑셀다운로드', href: '/Test/excelDown' },
  //   ]
  // }
]

// children 중 첫 번째 href를 상위 href로 승격
ROOT_NAV.forEach(node => {
  if (!node.href && Array.isArray(node.children)) {
    const firstHref = node.children.find(c => c.href)?.href
    if (firstHref) node.href = firstHref
  }
})

// ---------------------------------------------
// 사용자 권한 기반 네비 필터링
// ---------------------------------------------
export function applyProfessorFilter(navItems, clss) {
  const isProfGroup =
    clss === 'PROFESSOR' ||
    clss === 'ASSISTANT';

  // 교수/조교는 전체 메뉴가 보인다 → 아무것도 숨기지 않음
  if (isProfGroup) return navItems;

  // 일반 사용자는 professorOnly 메뉴를 제거한다
  const filterRecursive = (items) => {
    return items
      .map(item => {
        const filteredChildren = item.children ? filterRecursive(item.children) : [];

        // 일반 사용자: professorOnly=true 메뉴는 제거
        if (item.professorOnly === true) return null;

        // children에서 professorOnly만 제거된 상태 유지
        return { ...item, children: filteredChildren };
      })
      .filter(Boolean);
  };

  return filterRecursive(navItems);
}

/**
 * 공통: 깊이 제한 + 조건부 숨김 처리
 * @param {NavItem} node
 * @param {number} maxDepth          // 포함할 최대 깊이 (0=가상루트, 1=1뎁스, 2=2뎁스 ...)
 * @param {(node: NavItem, depth: number) => boolean} predicate
 * @param {number} [depth]
 * @returns {NavItem|undefined}
 */

function pruneTree(node, maxDepth, predicate, depth = 0) {
  if (!predicate(node, depth)) return undefined
  const next = { ...node }
  if (!next.href && Array.isArray(next.children)) {
    const firstHref = next.children.find(c => c.href)?.href
    if (firstHref) {
      next.href = firstHref
    }
  }
  if (!next.children || depth >= maxDepth) return next
  next.children = next.children
    .map(child => pruneTree(child, maxDepth, predicate, depth + 1))
    .filter(Boolean)
  return next
}

/** 내부 헬퍼: 배열 루트를 가상 루트로 감싸서 잘라낸 뒤 children만 반환 */
function sliceFromArrayRoot(rootArray, maxDepth, predicate) {
  const vroot = { label: 'ROOT', href: '/', children: rootArray }
  const pruned = pruneTree(vroot, maxDepth, predicate)
  return pruned?.children ?? []
}

/** 헤더(1뎁스)용: 1뎁스만 */
export function getHeaderNav(root = ROOT_NAV) {
  return sliceFromArrayRoot(root, 1, (node) => !node.hiddenInGnb)
}

/** 메가메뉴(2뎁스)용: 2뎁스까지 + 2뎁스의 subMain 숨김 */
export function getMegaNav(root = ROOT_NAV) {
  const pred = (node, depth) => {
    // hidden이면 언제나 제외
    if (node.hidden) return false
    // 2뎁스(subMain)은 제외
    if (depth === 2 && node.subMain) return false
     // roleOnly 속성이 있고 현재 사용자 role이 다르면 제외
    if (node.hiddenInGnb) return false
    return true
  }

  return sliceFromArrayRoot(root, 2, pred)
}

/** 사이트맵(3뎁스)용: 3뎁스까지, 4뎁스 이상 제거 */
export function getSitemapNav(root = ROOT_NAV) {
  const pred = (node, depth) => {
    if (node.hidden) return false
    if (node.hiddenInSitemap) return false

    if (!node.href && node.children && node.children.length > 0) return true

    return true
  }

  return sliceFromArrayRoot(root, 3, pred)
}


// URL 경로 문자열 정규화 (쿼리, 해시 제거 포함)
const norm = (p) => {
  if (!p) return '/'
  const cleaned = p
    .split(/[?#]/)[0]        // ✅ 쿼리와 해시 제거
    .replace(/\/{2,}/g, '/')
    .replace(/\/+$/, '')
  return cleaned === '' ? '/' : cleaned
}

// URL에서 언어 prefix 제거 (/en, 나중에 /ko 같은 거 생겨도 확장 가능)
export function stripLangPrefix(path) {
  if (!path) return '/';

  // /en → /
  if (path === '/en') return '/';

  // /en/... → /...
  if (path.startsWith('/en/')) {
    const stripped = path.slice(3); // '/en' 잘라냄
    return stripped === '' ? '/' : stripped;
  }

  // 그 외는 그대로
  return path;
}

/** NavItem 반환 */
export function findNodeByPath(pathname, nav = ROOT_NAV) {
  const target = norm(stripLangPrefix(pathname)); // ✅ 여기서만 strip

  let best = null;
  for (const item of nav) {
    const itemPath = norm(item.href); // nav href는 그대로

    if (item.children?.length) {
      const foundChild = findNodeByPath(target, item.children);
      if (foundChild) return foundChild;
    }

    if (itemPath === target) {
      best = item;
      return best;
    }
  }
  return best;
}

/** 브레드크럼 */
function pathMatch(navHref, actualPath) {
  if (!navHref) return false
  if (navHref.includes(':')) {
    const regex = new RegExp('^' + navHref.replace(/:[^/]+/g, '[^/]+') + '$')
    return regex.test(actualPath)
  }
  return navHref === actualPath
}

export function findBreadcrumbs(pathname, nav = ROOT_NAV, trail = []) {
  const nPath = norm(stripLangPrefix(pathname)); // ✅ 여기서도 strip

  for (const item of nav) {
    const itemPath = norm(item.href);
    const nextTrail = [
      ...trail,
      {
        label: item.label,
        href: item.href,
        subMain: item.subMain,
      },
    ];

    if (item.children?.length) {
      const found = findBreadcrumbs(nPath, item.children, nextTrail);
      if (found.length) return found;
    }

    if (pathMatch(itemPath, nPath)) {
      return nextTrail;
    }

    if (nPath.startsWith(itemPath + '/')) {
      const rest = nPath.slice(itemPath.length + 1);
      if (/^[a-z0-9_-]+$/i.test(rest)) {
        return nextTrail;
      }
    }
  }

  return [];
}

// 절대 URL인지 체크 (패밀리사이트 같은 거는 그대로 사용)
function isExternalHref(href) {
  return /^https?:\/\//i.test(href);
}

// 언어에 따라 실제 링크 생성
export function buildLangHref(href, lang) {
  if (!href) return href;
  if (isExternalHref(href)) return href; // 외부 링크는 그대로

  // canonical은 항상 "언어 prefix 없음" 기준으로 관리한다고 가정
  const canonical = href;

  if (lang === 'en') {
    if (canonical === '/') return '/en';
    return canonical.startsWith('/en/') ? canonical : `/en${canonical}`;
  }

  // lang === 'ko' (기본 언어)
  // 만약 실수로 /en 붙은 게 들어오면 제거
  if (canonical === '/en') return '/';
  if (canonical.startsWith('/en/')) {
    const stripped = canonical.replace(/^\/en/, '');
    return stripped === '' ? '/' : stripped;
  }

  return canonical;
}
